module.exports = __webpack_public_path__ + "img/fast-search-bg.e4413780.jpg";